var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12484 9.99967C8.12484 8.96414 8.9643 8.12467 9.99984 8.12467C11.0354 8.12467 11.8748 8.96414 11.8748 9.99967C11.8748 11.0352 11.0354 11.8747 9.99984 11.8747C8.9643 11.8747 8.12484 11.0352 8.12484 9.99967Z",
    fill: "#5F6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 9.99967C1.6665 11.3658 2.02064 11.8259 2.72891 12.7461C4.14314 14.5834 6.51493 16.6663 9.99984 16.6663C13.4847 16.6663 15.8565 14.5834 17.2708 12.7461C17.979 11.8259 18.3332 11.3658 18.3332 9.99967C18.3332 8.63353 17.979 8.17345 17.2708 7.25328C15.8565 5.41597 13.4847 3.33301 9.99984 3.33301C6.51493 3.33301 4.14314 5.41597 2.72891 7.25328C2.02064 8.17345 1.6665 8.63353 1.6665 9.99967ZM9.99984 6.87467C8.27395 6.87467 6.87484 8.27378 6.87484 9.99967C6.87484 11.7256 8.27395 13.1247 9.99984 13.1247C11.7257 13.1247 13.1248 11.7256 13.1248 9.99967C13.1248 8.27378 11.7257 6.87467 9.99984 6.87467Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.33a0687c8b4f6a2d7cc338306f295092.svg";
export { ForwardRef as ReactComponent };